import React from 'react';
import { styled } from 'styled-components';
const Error = (props) => {
    return (React.createElement(WarningStyled, null, props.messages.map((m) => (React.createElement("div", { className: "warning" }, m)))));
};
export default Error;
const WarningStyled = styled.div `
  .warning {
    border-radius: 3px;
    background-color: #ff5252;
    padding: 12px 15px;
    font-size: 0.8em;
    margin-bottom: 20px;
    width: 100%;
    background-image: none;
    border: 1px solid #ff5252;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    color: white;
  }
`;
//# sourceMappingURL=Error.js.map